import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, NgModel } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import * as XLSX from 'xlsx';
import { data } from 'jquery';

@Component({
  selector: 'app-listacceptbyheader',
  templateUrl: './listacceptbyheader.component.html',
  styleUrls: ['./listacceptbyheader.component.css']
})
export class ListacceptbyheaderComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('listdoc00', { static: false }) listdoc00Table: any;
  zone: string;
  supcode: string;
  Actiocmanager: UntypedFormGroup;
  newtable: any;

  constructor(private auth: Authenticationservice) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.userlv = userdata.userlevel

    this.Actiocmanager = new UntypedFormGroup({
      comment_takeask: new UntypedFormControl(''),
      comment_save: new UntypedFormControl(''),
      comment_accept: new UntypedFormControl(''),
      selecyear: new UntypedFormControl(''),
      selectzone: new UntypedFormControl(''),
      credit_approved: new UntypedFormControl(''),
      date: new UntypedFormControl(''),
    })
  }
  displaylist = ['no', 'doc_no', 'supportter', 'date', 'FMCODE', 'fullname', 'comment1', 'countmoney', 'credit_approved', 'dateapprove', 'Date_debt', 'bank', 'status', 'timeline', 'save'];
  ngOnInit(): void {
    this.LoadZone()
    let d1 = new Date(), d2 = new Date();
    d1.setDate(d1.getDate() - 7);
    this.dateSelet = [d1, d2];
    // this.Loadlistaskformoney();
    //this.dateSelet.fill(new Date());
  }
  selecyear = '6869';
  szone: string = null
  dateSelet: Date[] = []
  userlv = ''
  zonecode = '';
  fmcode = '';
  hurl = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/';

  isload = [false, false, false, false, false, false];

  ExportExcel() {
    let options: any = {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"
    };
    var currentDate = new Date();
    var dateLOC = currentDate.toLocaleString('th-TH', options);

    let wannafind = this.setselect[1];
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.listdoc00Table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, `รายการขอเกี้ยวที่อนุมัติแล้ว${this.selecyear}-${dateLOC}_${wannafind}.xlsx`);
  }
  resetdata() {
    if (this.newtable != undefined || this.newtable != null) {
      this.newtable.destroy();
    }
    setTimeout(() => {
      this.newtable = $(this.listdoc00Table.nativeElement).DataTable({ order: [[0, 'desc']] });
    }, 50);
  }

  LoadZone() {
    let url = this.hurl + "brdsqlapi/zoneGroup";
    axios.get(url)
      .then(res => {
        this.zonecode = (res.data.recordset);
      }).catch(err => { throw (err) })
  }

  applyFilter(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.list6566.filter = filterValue2.trim().toLowerCase();;
    if (this.list6566.paginator) {
      this.list6566.paginator.firstPage();
    }
  }

  date2Local(date: Date) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  setselect = [1, '', 0];
  // โหลดข้อมูล
  list6566: any;
  dataList: any = [];
  Loadlistaskformoney() {
    let sdate = [this.date2Local(this.dateSelet[0]), this.date2Local(this.dateSelet[1])];
    let szone = this.szone;
    let url = ''
    let fmcode = this.fmcode;
    let setselect = this.setselect;
    if (setselect[0] == 1) {
      url = `${this.hurl}dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance]&w=[YearID]='${this.selecyear}'and[supzone]='${szone}'and[doc_status]='4'`
    }
    else if (setselect[0] == 2) {
      url = `${this.hurl}dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance]&w=[YearID]='${this.selecyear}'and[doc_status]='4'and cast(dateapprove as date) between '${sdate[0]}'and '${sdate[1]}'`
    }
    else if (setselect[0] == 3) {
      url = `${this.hurl}dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance]&w=[YearID]='${this.selecyear}'and[doc_status]='4'and cast(Date_debt as date) between '${sdate[0]}'and '${sdate[1]}'`
    }
    else if (setselect[0] == 4) {
      url = `${this.hurl}dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance]&w=[YearID]='${this.selecyear}'and[doc_status]='4'and fmcode_b1='${fmcode}'`
    }
    console.log(szone, sdate);
    this.isload[1] = true;
    axios.get(url)
      .then(res => {
        this.isload[1] = false;
        let data = res.data;
        this.dataList = data
        this.setselect[2] = data.length;
        data.sort((a, b) => {
          return new Date(b.dateapprove).getTime() - new Date(a.dateapprove).getTime();
        });
        this.resetdata();

        /*
        this.list6566 = new MatTableDataSource(data);
        this.paginator.length = data.length;
        this.paginator.pageSize = 20;
        this.list6566.sort = this.sort;
        this.list6566.paginator = this.paginator;
        */
      })
      .catch(err => { throw (err) })
  }

  select_data() {
    let szone = this.szone;
    let syear = this.selecyear;
    if (szone != null && syear != null) this.Loadlistaskformoney()
    console.log('syear:', syear, ' | ', 'szone:', szone)
  }

  // 
  comment_accept = ''
  edit_approved(doc_id: string) {
    let comment = this.comment_accept//this.Actiocmanager.get('comment_save').value;
    let chkAccept = this.chkAccept;
    let url = this.hurl + "dbcps/update_getfactor_n?docid=" + doc_id + "&doc_status=4&comment6='" + comment + "'&credit_approved=" + this.credit_approved + "&bank='" + chkAccept[2] + "'&Date_debt='" + chkAccept[3] + "'";
    console.log('edit_approved_url', url)
    if (confirm("ยืนยันการทำรายการ")) {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] >= 1) {
            alert("บันทึกเรียบร้อย");
            this.Loadlistaskformoney();
          }
          else {
            alert("ไม่สำเร็จกรุณาลองใหม่");
          }
        }).catch(err => { throw (err) })
    }
    else { }

  }

  credit_approved = 0
  // ข้อมูลใน Modal
  chkAccept: Array<any> = [
    1 // สถานะ 1 อนุมัติได้                            
    , 0 //ที่จะอนุมัติ
    , '' //ธนาคาร
    , null //วันที่อนุมัติ
  ];
  datainmodal: any[];
  Datainmodel(data) {
    this.datainmodal = data//this.dataList.filter(el => el.docid == docid);
    let dated = data[0].Date_debt
    let date_d = this.date2Local(dated);
    let Date_debt = this.date2Local(new Date);
    if (date_d.length > 0) Date_debt = date_d;
    this.chkAccept = [1, data[0].money_amt, data[0].bank, Date_debt];
    this.credit_approved = data[0].credit_approved;
    /* 
    console.log('datain[]',this.datainmodal);
    console.log('chkAccept',this.chkAccept);
    */
  }
  ckcredit_approved() {
    if (this.chkAccept[1] < this.credit_approved) {
      this.chkAccept[0] = 3;
      alert('เงินที่อนุมัติ ' + this.credit_approved + ' ต้องน้อยกว่าหรือเท่ากับ ' + this.chkAccept[1]);
    }
    else if (this.credit_approved <= 0) {
      this.chkAccept[0] = 3;
      alert('เงินที่อนุมัติ ' + this.credit_approved + ' ต้องมากกว่า 0');
    }
    else this.chkAccept[0] = 1;
  }

  THtoLocalstring(date: string) {
    if (!date) return ''
    const date1 = new Date(date);
    let options: object = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }
  THtoLocalstring2(date: string) {
    if (!date) return ''
    const date1 = new Date(date);
    let options: object = {
      year: "numeric", month: "short", day: "numeric", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }
}
